import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-content-wrapper',
  imports: [TranslatePipe],
  templateUrl: './content-wrapper.component.html',
  styleUrl: './content-wrapper.component.css'
})
export class ContentWrapperComponent {
  @Input() title: string = '';

}
